import { render, staticRenderFns } from "./TarifeBolgeItem.vue?vue&type=template&id=301692fb&scoped=true"
import script from "./TarifeBolgeItem.vue?vue&type=script&lang=js"
export * from "./TarifeBolgeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301692fb",
  null
  
)

export default component.exports